(function () {
"use strict";
var DEBOUNCE = 150;
var ALLOWED_CHAR = /[A-Z0-9#&.:\u2606\u2661\u263A\uFE0E ]/;
var SYMBOLS = ["\u2661", "\u2606", "#", "&", "\u263A\uFE0E", ".", ":"];
function visLen(s) { return s.replace(/\uFE0E/g, "").length; }
function capText(s, max) { var out = "", vis = 0; for (var i = 0; i < s.length; i++) { var ch = s[i]; if (ch === "\uFE0E") { if (out.slice(-1) === "\u263A") out += ch; continue; } if (!ALLOWED_CHAR.test(ch)) continue; if (vis >= max) continue; out += ch; vis++; } return out; }
function alertRule(max) {
alert("Maximum " + max + " Characters with only English letters, numbers and the symbols: . : & # \u2661 \u2606 \u263A");
}
function debounce(fn, wait) {
var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); };
}
class PersonalizerWidget extends HTMLElement {
connectedCallback() {
if (this._init) return; this._init = true;
try { this.config = JSON.parse(this.querySelector(".pm-config").textContent); }
catch (e) { console.warn("[personalizer] bad config", e); return; }
if (!this.config || !this.config.fields) return;
this.formId = this.getAttribute("data-form-id");
this.form = (this.formId && document.getElementById(this.formId))
|| document.querySelector("product-form form.js-product-form:not(.pplr_atc_form):not(.js-instalments-form)")
|| document.querySelector("form.js-product-form:not(.pplr_atc_form):not(.js-instalments-form)")
|| this.closest("form");
if (this.form) this.formId = this.form.getAttribute("id") || this.formId;
this.optional = this.getAttribute("data-optional") === "true";
this.values = {};
this.inputs = {};
this.baseImg = null;
this._variants = (this.config.preview && this.config.preview.variants) || [];
this._variantImages = {};
this._variantAvail = {};
this._variants.forEach(function (v) { this._variantImages[v.id] = v.image; this._variantAvail[v.id] = (v.available !== false); }, this);
this.buildTrigger();
this.buildModal();
this.buildNativeInputs();
this.wireForm();
this.wireVariant();
if (this.config.preview && this.config.preview.enabled) this.setupCanvas();
this.validate();
}
buildTrigger() {
var wrap = document.createElement("div");
wrap.innerHTML =
'<button type="button" class="pm-personalize-btn">' +
'<svg class="pm-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>' +
'<span class="pm-btn-text">ADD PERSONALIZATION</span>' +
'</button>';
this.appendChild(wrap);
this.triggerBtn = wrap.querySelector(".pm-personalize-btn");
this.triggerBtn.addEventListener("click", this.open.bind(this));
}
buildModal() {
var cfg = this.config;
var modal = document.createElement("div");
modal.className = "pm-modal";
modal.setAttribute("role", "dialog");
modal.setAttribute("aria-modal", "true");
var previewCol = (cfg.preview && cfg.preview.enabled)
? '<div class="pm-preview"><div class="pm-preview__stage"><canvas class="pm-canvas" width="' + cfg.preview.w + '" height="' + cfg.preview.h + '"></canvas></div><div class="pm-variants"></div></div>' : '';
modal.innerHTML =
'<div class="pm-modal__overlay"></div>' +
'<div class="pm-modal__dialog">' +
'<button type="button" class="pm-modal__close" aria-label="Close">&times;</button>' +
previewCol +
'<div class="pm-fields">' +
'<h2 class="pm-fields__title">' + esc(cfg.setName || "Personalise") + '</h2>' +
(cfg.setSub ? '<p class="pm-fields__sub">' + esc(cfg.setSub) + '</p>' : '') +
'<div class="pm-fields__list"></div>' +
'<div class="pm-actions"><button type="button" class="pm-btn-done">Add to cart</button></div>' +
'</div>' +
'</div>';
document.body.appendChild(modal);
this.modal = modal;
this.canvas = modal.querySelector(".pm-canvas");
var list = modal.querySelector(".pm-fields__list");
cfg.fields.forEach(function (f, i) { list.appendChild(this.buildField(f, i)); }, this);
this.buildVariantSwatches();
modal.querySelector(".pm-modal__overlay").addEventListener("click", this.close.bind(this));
modal.querySelector(".pm-modal__close").addEventListener("click", this.close.bind(this));
modal.querySelector(".pm-btn-done").addEventListener("click", this.addToCartFromModal.bind(this));
document.addEventListener("keydown", function (e) { if (e.key === "Escape" && this.modal.classList.contains("is-open")) this.close(); }.bind(this));
}
buildField(f, i) {
var row = document.createElement("div");
row.className = "pm-field"; row.dataset.key = f.key;
var self = this;
if (f.type === "text") {
var max = f.maxlength || 4;
row.innerHTML =
'<label class="pm-field__label" for="pm-f-' + i + '">' + esc(f.label) +
(f.maxlength ? '<span class="pm-field__count">0/' + f.maxlength + '</span>' : '') + '</label>' +
'<input class="pm-input' + (f.uppercase ? ' pm-uppercase' : '') + '" id="pm-f-' + i + '" type="text" autocomplete="off">' +
'<div class="pm-symbols"></div>' +
'<div class="pm-error">This field is required.</div>';
var input = row.querySelector(".pm-input");
var count = row.querySelector(".pm-field__count");
input.addEventListener("input", function () {
var raw = input.value.toUpperCase();
var clean = capText(raw, max);
var allowedOnly = raw.split("").filter(function (ch) { return ch === "\uFE0E" || ALLOWED_CHAR.test(ch); }).join("");
if (allowedOnly !== raw || visLen(clean) < visLen(allowedOnly)) alertRule(max);
input.value = clean;
self.values[f.key] = clean;
if (count) count.textContent = visLen(clean) + "/" + max;
self.onChange();
});
var bar = row.querySelector(".pm-symbols");
SYMBOLS.forEach(function (sym) {
var b = document.createElement("button");
b.type = "button"; b.className = "pm-symbol"; b.setAttribute("aria-label", "Insert " + sym); b.textContent = sym;
b.addEventListener("click", function () {
var cur = input.value || "";
if (visLen(cur) >= max) { alertRule(max); return; }
input.value = cur + sym;
self.values[f.key] = input.value;
if (count) count.textContent = visLen(input.value) + "/" + max;
self.onChange(); input.focus();
});
bar.appendChild(b);
});
this.inputs[f.key] = input;
} else if (f.type === "color") {
var sw = f.choices.map(function (c, j) {
return '<button type="button" class="pm-swatch" data-val="' + esc(c.label) + '" title="' + esc(c.label) + '" style="background:' + esc(c.swatch || c.hex) + '"' + (j === 0 ? ' data-selected="true"' : '') + '></button>';
}).join("");
row.innerHTML = '<span class="pm-field__label">' + esc(f.label) + '</span><div class="pm-swatches">' + sw + '</div>';
this.values[f.key] = f.choices[0].label;
this._colorHex = this._colorHex || {};
this._colorHex[f.key] = f.choices[0].hex;
row.querySelectorAll(".pm-swatch").forEach(function (el) {
el.addEventListener("click", function () {
row.querySelectorAll(".pm-swatch").forEach(function (s) { s.removeAttribute("data-selected"); });
el.setAttribute("data-selected", "true");
self.values[f.key] = el.dataset.val;
var choice = f.choices.filter(function (c) { return c.label === el.dataset.val; })[0];
self._colorHex[f.key] = choice ? choice.hex : "#000";
self.onChange();
});
});
}
return row;
}
buildNativeInputs() {
var host = document.createElement("div"); host.className = "pm-native";
this.config.fields.forEach(function (f) {
var el = document.createElement("input");
el.type = "hidden"; el.name = "properties[" + f.key + "]"; el.value = this.values[f.key] || "";
if (this.formId) el.setAttribute("form", this.formId);
host.appendChild(el); this._natives = this._natives || {}; this._natives[f.key] = el;
}, this);
if (this.config.preview && this.config.preview.enabled && this.config.preview.save !== false && this.config.preview.key) {
var file = document.createElement("input");
file.type = "file"; file.name = "properties[" + this.config.preview.key + "]";
if (this.formId) file.setAttribute("form", this.formId);
host.appendChild(file); this.fileInput = file;
}
var mark = document.createElement("input");
mark.type = "hidden"; mark.name = "properties[_personalized]"; mark.value = "true";
if (this.formId) mark.setAttribute("form", this.formId);
host.appendChild(mark);
this._nativeHost = host;
if (!this.optional) { if (this.form) this.form.appendChild(host); else this.appendChild(host); }
}
attachNatives() {
if (!this._nativeHost) return;
if (this.form) { if (this._nativeHost.parentNode !== this.form) this.form.appendChild(this._nativeHost); }
else if (!this._nativeHost.parentNode) this.appendChild(this._nativeHost);
}
detachNatives() {
if (this._nativeHost && this._nativeHost.parentNode) this._nativeHost.parentNode.removeChild(this._nativeHost);
}
setupCanvas() {
var p = this.config.preview;
this.baseImg = new Image();
this.baseImg.crossOrigin = "anonymous";
this.baseImg.onload = function () { this._imgReady = true; this.renderCanvas(); }.bind(this);
this.baseImg.onerror = function () { this._imgReady = false; }.bind(this);
this._curImgSrc = this.variantImageUrl() || p.baseImage;
this.baseImg.src = this._curImgSrc;
if (document.fonts && document.fonts.load) {
document.fonts.load(p.fontPx + 'px "PplrBrand"').then(function () { this._fontReady = true; this.renderCanvas(); }.bind(this)).catch(function () {});
}
}
variantImageUrl() {
if (!this.form) return null;
var idEl = this.form.querySelector('[name="id"]');
if (!idEl) return null;
return this._variantImages[idEl.value] || null;
}
wireVariant() {
if (!this.form) return;
var handler = this.syncVariantImage.bind(this);
this.form.addEventListener("change", handler, false);
document.addEventListener("variant:change", handler);
document.addEventListener("on:variant:change", handler);
}
syncVariantImage() {
if (!this.baseImg) return;
var url = this.variantImageUrl();
if (url && url !== this._curImgSrc) { this._curImgSrc = url; this._imgReady = false; this.baseImg.src = url; }
this.updateVariantSwatchSelected();
this.refreshATC();
}
buildVariantSwatches() {
if (!this.modal) return;
var wrap = this.modal.querySelector(".pm-variants");
if (!wrap) return;
if (!this._variants || this._variants.length < 2) { wrap.style.display = "none"; return; }
var self = this;
this._variants.forEach(function (v) {
var b = document.createElement("button");
b.type = "button"; b.className = "pm-variant-swatch"; b.dataset.id = v.id;
b.title = v.title || ""; b.setAttribute("aria-label", v.title || "Colour");
if (v.available === false) { b.classList.add("is-soldout"); b.setAttribute("aria-disabled", "true"); b.title = (v.title || "") + " \u2014 Sold out"; }
b.style.backgroundImage = 'url("' + v.image + '")';
b.addEventListener("click", function () { self.setVariant(v.id); });
wrap.appendChild(b);
});
this.updateVariantSwatchSelected();
}
setVariant(id) {
var idEl = this.form && this.form.querySelector('[name="id"]');
if (idEl) idEl.value = id;
var url = this._variantImages[id];
if (url) { this._curImgSrc = url; this._imgReady = false; this.baseImg.src = url; }
this.updateVariantSwatchSelected();
this.refreshATC();
}
updateVariantSwatchSelected() {
if (!this.modal) return;
var wrap = this.modal.querySelector(".pm-variants");
if (!wrap) return;
var idEl = this.form && this.form.querySelector('[name="id"]');
var current = idEl ? String(idEl.value) : null;
wrap.querySelectorAll(".pm-variant-swatch").forEach(function (el) {
if (el.dataset.id === current) el.setAttribute("data-selected", "true");
else el.removeAttribute("data-selected");
});
}
variantAvailable(id) {
if (id == null) { var el = this.form && this.form.querySelector('[name="id"]'); id = el ? el.value : null; }
if (id == null) return true;
return this._variantAvail[id] !== false;
}
refreshATC() {
if (!this.modal) return;
var btn = this.modal.querySelector(".pm-btn-done");
if (!btn) return;
var avail = this.variantAvailable();
btn.disabled = !avail;
btn.textContent = avail ? "Add to cart" : "Sold out";
btn.classList.toggle("pm-soldout", !avail);
}
renderCanvas() {
if (!this.canvas || !this._imgReady) return;
var p = this.config.preview, ctx = this.canvas.getContext("2d");
ctx.clearRect(0, 0, p.w, p.h);
var r = Math.min(p.w / this.baseImg.width, p.h / this.baseImg.height);
var dw = this.baseImg.width * r, dh = this.baseImg.height * r;
ctx.drawImage(this.baseImg, (p.w - dw) / 2, (p.h - dh) / 2, dw, dh);
var placements = p.placements;
if (!placements) {
var tf = this.config.fields.filter(function (f) { return f.previewText; })[0];
var cf = this.config.fields.filter(function (f) { return f.previewColor; })[0];
placements = [{ textKey: tf ? tf.key : null, colorKey: cf ? cf.key : null, x: p.x, y: p.y, fontPx: p.fontPx, align: p.align }];
}
placements.forEach(function (pl) {
var txt = pl.textKey ? (this.values[pl.textKey] || "") : "";
if (!txt) return;
txt = txt.replace(/\uFE0E/g, "");
ctx.font = (pl.fontPx || p.fontPx) + 'px "PplrBrand", serif';
ctx.fillStyle = pl.colorKey ? (this._colorHex[pl.colorKey] || "#000") : "#000";
ctx.textAlign = pl.align || p.align || "center";
ctx.textBaseline = "middle";
ctx.fillText(txt, pl.x, pl.y);
}, this);
this.updatePreviewFile();
}
updatePreviewFile() {
if (!this.fileInput || !this.canvas) return;
try {
this.canvas.toBlob(function (blob) {
if (!blob) return;
var file = new File([blob], "preview-" + Date.now() + ".png", { type: "image/png" });
var dt = new DataTransfer(); dt.items.add(file); this.fileInput.files = dt.files;
}.bind(this), "image/png");
} catch (e) {  }
}
onChange() {
this.config.fields.forEach(function (f) { if (this._natives[f.key]) this._natives[f.key].value = this.values[f.key] || ""; }, this);
if (this.config.preview && this.config.preview.enabled) this._renderDebounced();
this.validate();
}
get _renderDebounced() { if (!this.__rd) this.__rd = debounce(this.renderCanvas.bind(this), DEBOUNCE); return this.__rd; }
validate() {
var ok = this.config.fields.every(function (f) {
if (!f.required) return true;
return (this.values[f.key] || "").trim().length > 0;
}, this);
this.valid = ok;
if (this.modal) this.config.fields.forEach(function (f) {
if (!f.required) return;
var row = this.modal.querySelector('.pm-field[data-key="' + cssEsc(f.key) + '"]');
if (row) row.dataset.invalid = (this.values[f.key] || "").trim().length > 0 ? "false" : "true";
}, this);
return ok;
}
addToCartFromModal() {
if (!this.variantAvailable()) { this.refreshATC(); return; }
if (!this.validate()) {
var first = this.modal.querySelector('.pm-field[data-invalid="true"] .pm-input');
if (first) first.focus();
return;
}
if (this.optional) this.attachNatives();
this.close();
this.submitCart();
}
wireForm() {
if (!this.form) return;
var self = this;
document.addEventListener("submit", function (e) {
if (e.target !== self.form) return;
e.preventDefault(); e.stopImmediatePropagation();
if (self.optional) { self.detachNatives(); self.submitCart(); return; }
if (!self.validate()) { self.open(); return; }
self.submitCart();
}, true);
}
submitCart() {
if (!this.variantAvailable()) return;
var btn = this.form.querySelector('[name="add"]');
var label = btn ? btn.innerHTML : "";
if (btn) { btn.setAttribute("aria-busy", "true"); btn.disabled = true; }
fetch("/cart/add.js", { method: "POST", body: new FormData(this.form), headers: { Accept: "application/json" } })
.then(function (r) { return r.json(); })
.then(function () {
if (typeof window.handleFloCartBtn === "function") { window.handleFloCartBtn(); return; }
document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", { bubbles: true }));
document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open"));
})
.catch(function () { window.location.href = "/cart"; })
.finally(function () { if (btn) { btn.removeAttribute("aria-busy"); btn.disabled = false; btn.innerHTML = label; } });
}
open() { this.syncVariantImage(); this.refreshATC(); this.modal.classList.add("is-open"); document.documentElement.style.overflow = "hidden"; var fi = this.modal.querySelector(".pm-input"); if (fi) setTimeout(function () { fi.focus(); }, 30); }
close() { this.modal.classList.remove("is-open"); document.documentElement.style.overflow = ""; }
}
function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]; }); }
function cssEsc(s) { return String(s).replace(/["\\]/g, "\\$&"); }
if (!customElements.get("personalizer-widget")) customElements.define("personalizer-widget", PersonalizerWidget);
})();
